// 学生管理
export default [
  {
    path: '/student/faculty',
    component: resolve => require(['@/pages/student/faculty.vue'], resolve),
    name: 'faculty',
    meta: {
      title: '学院管理'
    }
  },
  {
    path: '/student/degree',
    component: resolve => require(['@/pages/student/degree.vue'], resolve),
    name: 'degree',
    meta: {
      title: '学位管理'
    }
  },
  {
    path: '/student/student',
    component: resolve => require(['@/pages/student/student.vue'], resolve),
    name: 'student',
    meta: {
      title: '学生管理'
    }
  },
  {
    path: '/facultySecond',
    component: resolve => require(['@/pages/student/facultySecond.vue'], resolve),
    name: 'facultySecond',
    meta: {
      title: '学院管理'
    }
  },
  {
    path: '/studentClassesMange',
    component: resolve => require(['@/pages/student/studentClassesMange.vue'], resolve),
    name: 'studentClassesMange',
    meta: {
      title: '班级管理'
    }
  },
  {
    path: '/studentDegree',
    component: resolve => require(['@/pages/student/studentDegree.vue'], resolve),
    name: 'studentDegree',
    meta: {
      title: '学位管理'
    }
  },
  // {
  //   path: '/studentMange',
  //   component: resolve => require(['@/pages/student/studentMange.vue'], resolve),
  //   meta: {
  //     title: '学生管理'
  //   }
  // },
  {
    path: '/student/student-statistics',
    component: resolve => require(['@/pages/student/student-statistics.vue'], resolve),
    name: 'student-statistics',
    meta: {
      title: '学生统计'
    }
  },
  {
    path: '/student/studentMangeNew',
    component: resolve => require(['@/pages/student/studentMangeNew.vue'], resolve),
    name: 'studentMangeNew',
    meta: {
      title: '学生管理'
    }
  },
  {
    path: '/student/lessNationalManage',
    component: resolve => require(['@/pages/student/lessNationalManage.vue'], resolve),
    name: 'lessNationalManage',
    meta: {
      title: '少数民族管理'
    }
  },
  {
    path: '/student/studentMangeFilesChanges',
    component: resolve => require(['@/pages/student/studentMangeFilesChanges.vue'], resolve),
    name: 'studentMangeFilesChanges',
    meta: {
      title: '档案异动学生管理'
    }
  },
  {
    path: '/student/facultyMajorManage',
    component: resolve => require(['@/pages/student/facultyMajorManage.vue'], resolve),
    name: 'facultyMajorManage',
    meta: {
      title: '院系专业班级'
    }
  },
  {
    path: '/student/healthCodeError',
    component: resolve => require(['@/pages/student/healthCodeError.vue'], resolve),
    name: 'healthCodeError',
    meta: {
      title: '绑定健康码异常查询'
    }
  },
  {
    path: '/student/graduateArchives',
    component: resolve => require(['@/pages/student/graduateArchives.vue'], resolve),
    name: 'graduateArchives',
    meta: {
      title: '毕业生档案审核'
    }
  },
  {
    path: '/student/graduateArchivesManage',
    component: resolve => require(['@/pages/student/graduateArchivesManage.vue'], resolve),
    name: 'graduateArchivesManage',
    meta: {
      title: '毕业生档案管理'
    }
  },
  {
    path: '/student/studentPlacement',
    component: resolve => require(['@/pages/student/studentPlacement.vue'], resolve),
    name: 'StudentPlacement',
    meta: {
      title: '新生分班'
    }
  },
  {
    path: '/student/newStudentWorkManage',
    component: resolve => require(['@/pages/student/newStudentWorkManage.vue'], resolve),
    name: 'newStudentWorkManage',
    meta: {
      title: '新生管理'
    }
  },
  {
    path: '/student/newStudentAudit',
    component: resolve => require(['@/pages/student/newStudentAudit.vue'], resolve),
    name: 'graduateArchivesManage',
    meta: {
      title: '信息采集'
    }
  },
  {
    path: '/student/AutumnQRcode',
    component: resolve => require(['@/pages/student/AutumnQRcode.vue'], resolve),
    name: 'AutumnQRcode',
    meta: {
      title: '秋季入校码'
    }
  },
  {
    path: '/student/nucleicAcidPage',
    component: resolve => require(['@/pages/student/nucleicAcidPage.vue'], resolve),
    name: 'nucleicAcidPage',
    meta: {
      title: '核酸采集'
    }
  },
  {
    path: '/student/armCloth',
    component: resolve => require(['@/pages/student/armCloth.vue'], resolve),
    name: 'armCloth',
    meta: {
      title: '军训服装'
    }
  },
  {
    path: '/student/oneInchPhoto',
    component: resolve => require(['@/pages/student/oneInchPhoto.vue'], resolve),
    name: 'oneInchPhoto',
    meta: {
      title: '一寸照片'
    }
  },
  {
    path: '/student/selectionNumber',
    component: resolve => require(['@/pages/student/selectionNumber.vue'], resolve),
    name: 'selectionNumber',
    meta: {
      title: '学生选号'
    }
  },
  {
    path: '/student/leaveConfiguration',
    component: resolve => require(['@/pages/student/leaveConfiguration.vue'], resolve),
    name: 'leaveConfiguration',
    meta: {
      title: '请假续假配置'
    }
  },
  {
    path: '/student/oneClick',
    component: resolve => require(['@/pages/student/oneClick.vue'], resolve),
    name: 'oneClick',
    meta: {
      title: '一键配置'
    }
  },
  {
    path: '/student/archiveMove',
    component: resolve => require(['@/pages/student/studentArchiveMove'], resolve),
    name: 'studentArchiveMove',
    meta: {
      title: '档案异动管理'
    }
  },
  {
    path: '/student/povertyData',
    component: resolve => require(['@/pages/student/povertyData.vue'], resolve),
    name: 'povertyData',
    meta: {
      title: '监测对象数据查询'
    }
  },
  {
    path: '/student/courseSelection',
    component: resolve => require(['@/pages/courseSelection/courseSelection.vue'], resolve),
    name: 'courseSelection',
    meta: {
      title: '学生选课'
    }
  },
  {
    path: '/student/courseSelectionDetail',
    component: resolve => require(['@/pages/courseSelection/courseSelectionDetail.vue'], resolve),
    name: 'courseSelectionDetail',
    meta: {
      title: '学生选课详情'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/student.js